function initSplitVideoBanner(root) {
  root.querySelectorAll('.split-video-banner-media').forEach(function (media) {
    if (media.dataset.splitVideoBannerInit) return;
    media.dataset.splitVideoBannerInit = 'true';

    var video = media.querySelector('video');
    var toggleBtn = media.querySelector('.split-video-banner-toggle-btn');
    if (!video || !toggleBtn) return;

    function togglePlay() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    toggleBtn.addEventListener('click', togglePlay);
    video.addEventListener('click', togglePlay);

    video.addEventListener('play', function () {
      media.classList.add('has-played');
      media.classList.add('is-video-playing');
    });

    video.addEventListener('pause', function () {
      media.classList.remove('is-video-playing');
    });

    video.addEventListener('ended', function () {
      media.classList.remove('has-played');
      media.classList.remove('is-video-playing');
      video.currentTime = 0;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initSplitVideoBanner(document);
  });
} else {
  initSplitVideoBanner(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initSplitVideoBanner(event.target);
});
